const { createSelector } = require('reselect')

const selectCart = (state) => state['marketplace.marketCart'].cart

const cart = () => createSelector([selectCart], (show) => show.data)

const cartError = () => createSelector([selectCart], (show) => show.error)

const cartLoading = () => createSelector([selectCart], (show) => show.loading)

//Services Cart

const selectServicesCart = (state) => state['marketplace.marketCart'].servicesCart

const servicesCart = () => createSelector([selectServicesCart], (show) => show.data)

const servicesCartError = () => createSelector([selectServicesCart], (show) => show.error)

const servicesCartLoading = () => createSelector([selectServicesCart], (show) => show.loading)

//

const selectCount = (state) => state['marketplace.marketCart'].count

const count = () => createSelector([selectCount], (show) => show.data)

const countError = () => createSelector([selectCount], (show) => show.error)

const countLoading = () => createSelector([selectCount], (show) => show.loading)

const selectCreate = (state) => state['marketplace.marketCart'].create

const create = () => createSelector([selectCreate], (crt) => crt.data)

const createError = () => createSelector([selectCreate], (crt) => crt.error)

const createLoading = () => createSelector([selectCreate], (crt) => crt.loading)


const selectServicesCreate = (state) =>
  state['marketplace.marketCart'].servicesCreate

const ServicesCreate = () =>
  createSelector([selectServicesCreate], (crt) => crt.data)

const ServicesCreateError = () =>
  createSelector([selectServicesCreate], (crt) => crt.error)

const ServicesCreateLoading = () =>
  createSelector([selectServicesCreate], (crt) => crt.loading)

const selectDelete = (state) => state['marketplace.marketCart'].del

const del = () => createSelector([selectDelete], (rm) => rm.data)

const delError = () => createSelector([selectDelete], (rm) => rm.error)

const delLoading = () => createSelector([selectDelete], (rm) => rm.loading)

const selectReOrder = (state) => state['marketplace.marketCart'].reOrder

const reOrder = () => createSelector([selectReOrder], (rm) => rm.data)

const reOrderError = () => createSelector([selectReOrder], (rm) => rm.error)

const reOrderLoading = () => createSelector([selectReOrder], (rm) => rm.loading)

module.exports = {
  cart,
  cartError,
  cartLoading,

  count,
  countError,
  countLoading,

  create,
  createError,
  createLoading,

  del,
  delError,
  delLoading,

  reOrder,
  reOrderLoading,
  reOrderError,

  ServicesCreate,
  ServicesCreateError,
  ServicesCreateLoading,

  servicesCart,
  servicesCartError,
  servicesCartLoading
}
